/* ============================================================
   skinmade — Globales Login-Modul (NATIVER SHOPIFY-LOGIN)
   Umgestellt 2026-08-14: Auth-Quelle ist jetzt der native Shopify-Customer
   ({{ customer }} → window.SM_CUSTOMER), NICHT mehr apilogin (Email+Bday+PLZ).
   - Verified-State = eingeloggter Shopify-Customer (window.SM_CUSTOMER.loggedIn)
   - Login = Redirect auf /account/login?return_url=… (Nudge-Modal davor)
   - Logout = /account/logout
   - Personalisierungs-Daten laufen weiter über apilogin, aber per Email (Stage 5)
   Public API (SmLogin / SmCart) bleibt stabil, damit Gates unverändert laufen.

   ⚠️ Beim Switch auf New Customer Accounts nur LOGIN_URL/LOGOUT_URL ändern.
   ============================================================ */

(function (window) {
  'use strict';

  // Zentrale Login-/Logout-URLs. New Customer Accounts (2026-08-15): Login läuft
  // über die Shopify-gehostete URL /customer_authentication/login, Rücksprung via
  // ?return_to= (NICHT return_url). Diese URL funktioniert erst NACH der Store-
  // Umstellung auf New Accounts.
  var LOGIN_URL  = '/customer_authentication/login';
  var LOGOUT_URL = '/account/logout';

  // ----- i18n (sm-i18n layer) ---------------------------------
  function t(key, vars) {
    return (window.SM_I18N && typeof window.SM_I18N.t === 'function')
      ? window.SM_I18N.t(key, vars)
      : key;
  }

  // ----- Locale-aware Ziel-URL --------------------------------
  function buildLocaleDest(target) {
    var root = (window.SM_ROOT || '/').replace(/\/$/, '');   // '' (DE) oder '/en'
    if (!target) { target = '/pages/profil'; }
    if (/^https?:/i.test(target)) { return target; }
    if (target.charAt(0) !== '/') { target = '/' + target; }
    if (root && (target === root || target.indexOf(root + '/') === 0)) { return target; }
    return root + target;
  }

  // Baut die native Login-URL mit return_to (locale-aware Ziel). New Accounts
  // nutzt return_to als Rücksprung-Parameter.
  function buildLoginUrl(returnUrl) {
    var dest = buildLocaleDest(returnUrl || '/pages/profil');
    return LOGIN_URL + '?return_to=' + encodeURIComponent(dest);
  }

  // ----- Verified-State aus dem nativen Shopify-Customer ------
  // window.SM_CUSTOMER wird serverseitig in theme.liquid aus {{ customer }}
  // gesetzt: { loggedIn, email, firstName, id }.
  var Storage = {
    get isVerified() {
      return !!(window.SM_CUSTOMER && window.SM_CUSTOMER.loggedIn);
    },
    get email() {
      return (window.SM_CUSTOMER && window.SM_CUSTOMER.email) || '';
    },
    get name() {
      return (window.SM_CUSTOMER && window.SM_CUSTOMER.firstName) || '';
    },
    get userId() {
      return (window.SM_CUSTOMER && window.SM_CUSTOMER.id) ? String(window.SM_CUSTOMER.id) : '';
    },
    // consultantId wird bewusst NICHT mehr beim Login gesetzt (Attribution läuft
    // über Apilogin-Owner; nur ein Affiliate-Link überschreibt via skinmade-affiliate).
    get consultantId() { return ''; }
  };

  // ----- Modal Controller (Nudge, KEIN Login-Formular mehr) ---
  var modal, goBtn, msgEl, defaultMessage;
  var pendingReturnUrl = null;

  function init() {
    modal = document.getElementById('sm-login-modal');

    if (modal) {
      goBtn  = document.getElementById('sm-login-go');
      msgEl  = document.getElementById('sm-modal-message');
      defaultMessage = msgEl ? msgEl.textContent : '';

      if (goBtn) {
        goBtn.addEventListener('click', function () {
          window.location.href = buildLoginUrl(pendingReturnUrl);
        });
      }
      modal.querySelectorAll('[data-sm-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
      });
    }

    // Render verifizierte Namen in alle [data-sm-name] elements
    renderNames();
    window.addEventListener('sm:login',  renderNames);
    window.addEventListener('sm:logout', renderNames);

    // Login-Links im Header / Menü hijacken
    hijackLoginLinks();
    if (window.SM_I18N_READY && typeof window.SM_I18N_READY.then === 'function') {
      window.SM_I18N_READY.then(syncLoginLinkText);
    }

    // Checkout-Email Pre-Fill hijack
    initCheckoutEmailPrefill();

    // Mobile-Nav-Parent-Links direkt navigieren statt Sub-Menü ausklappen
    initMobileNavDirectNav();
  }

  // ----- Mobile-Nav: Parent-Items mit echter href direkt navigieren ---
  function initMobileNavDirectNav() {
    if (document._smMobileNavFixed) return;
    document._smMobileNavFixed = true;

    document.addEventListener('click', function (e) {
      var link = e.target.closest('.mobile-navigation-drawer .navigation__link');
      if (!link) return;
      var item = link.parentElement;
      if (!item || !item.classList.contains('navigation__item--with-children')) return;
      var href = link.getAttribute('href');
      if (!href || href === '#') return;

      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = href;
    }, true);
  }

  function isLoginLinkLike(text, href) {
    return /^(login|anmelden|einloggen|logout|abmelden|mein konto|my account)$/i.test(text) ||
           /\/account\/login/i.test(href) ||
           /\/account\/register/i.test(href) ||
           /\/pages\/reorder-login/i.test(href) ||
           /\/pages\/closed-shop-login/i.test(href);
  }

  function isInsideHeaderArea(el) {
    return !!el.closest(
      'header, nav, .header, .mobile-nav, .drawer, .drawer__menu, ' +
      '.mobile-menu, .mobile-navigation, .mobile-navigation-drawer, ' +
      '.navigation-drawer, .navigation, .navigation--main, ' +
      '.cc-popup--left, .cc-popup--right, ' +
      '[data-section-type="header"], [data-section-type="cart-drawer"], ' +
      '.header-nav, #site-nav, #mobile-nav'
    );
  }

  function hijackLoginLinks() {
    document.querySelectorAll('a').forEach(function (link) {
      if (link.dataset.smLoginHijacked) return;
      if (link.hasAttribute('data-sm-account-link')) return;
      var text = (link.textContent || '').trim();
      var href = link.getAttribute('href') || '';
      if (!isLoginLinkLike(text, href)) return;
      if (!isInsideHeaderArea(link)) return;

      link.dataset.smLoginHijacked = 'true';
      link.dataset.smOriginalText = text || 'Login';
    });

    if (!document._smLoginDelegated) {
      document._smLoginDelegated = true;
      document.addEventListener('click', function (e) {
        if (e.target.closest(
          '.menu-toggle, .mobile-menu-toggle, .header__icon-menu, ' +
          '.header__menu-toggle, [aria-controls*="menu" i], ' +
          '[aria-controls*="navigation" i], .navigation-toggle, ' +
          'button[aria-label*="menü" i], button[aria-label*="menu" i]'
        )) {
          setTimeout(function () {
            document.querySelectorAll('a').forEach(function (link) {
              if (link.dataset.smLoginHijacked) return;
              if (link.hasAttribute('data-sm-account-link')) return;
              var t = (link.textContent || '').trim();
              var h = link.getAttribute('href') || '';
              if (!isLoginLinkLike(t, h)) return;
              if (!isInsideHeaderArea(link)) return;
              link.dataset.smLoginHijacked = 'true';
              link.dataset.smOriginalText = t || 'Login';
            });
            syncLoginLinkText();
          }, 300);
        }

        var link = e.target.closest('a');
        if (!link) return;
        if (link.hasAttribute('data-sm-account-link')) return;
        var text = (link.textContent || '').trim();
        var href = link.getAttribute('href') || '';
        if (!isLoginLinkLike(text, href)) return;
        if (!isInsideHeaderArea(link)) return;

        e.preventDefault();
        e.stopPropagation();
        if (Storage.isVerified) {
          logout();
        } else {
          // Header-Login = Intent "ich will zu mir" → nach Login auf Profil.
          window.location.href = buildLoginUrl('/pages/profil');
        }
      }, true);
    }

    syncLoginLinkText();
  }

  function syncLoginLinkText() {
    document.querySelectorAll('[data-sm-login-hijacked]').forEach(function (link) {
      if (Storage.isVerified) {
        link.textContent = t('smLogin.logout');
      } else {
        link.textContent = link.dataset.smOriginalText || t('smLogin.login');
      }
    });
  }

  function capitalizeName(raw) {
    if (!raw) return '';
    return raw
      .toLowerCase()
      .split(/([\s\-])/)
      .map(function (part) {
        if (!part || /^\s+$/.test(part) || part === '-') return part;
        return part.charAt(0).toUpperCase() + part.slice(1);
      })
      .join('');
  }

  function renderNames() {
    if (!Storage.isVerified) return;
    var displayName = capitalizeName(Storage.name);
    if (!displayName) return;
    document.querySelectorAll('[data-sm-name]').forEach(function (el) {
      el.textContent = displayName;
    });
  }

  // openModal: zeigt den Nudge (Message + "Jetzt anmelden"→Redirect). Ohne Modal
  // im DOM → direkter Redirect (Fallback), damit Gates immer funktionieren.
  function openModal(opts) {
    opts = opts || {};
    pendingReturnUrl = opts.returnUrl || null;

    if (!modal || !goBtn) {
      window.location.href = buildLoginUrl(pendingReturnUrl);
      return;
    }

    if (msgEl) msgEl.textContent = opts.message || defaultMessage;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { try { goBtn.focus(); } catch (e) {} }, 50);
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    pendingReturnUrl = null;
  }

  function logout() {
    // Cart-Attribute invalidieren (Berater-Kontext-Leak vermeiden), dann native
    // Shopify-Abmeldung. Locale-aware Rücksprung auf die Startseite.
    var dest = (window.SM_ROOT || '/');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { 'consultant_id': '', 'referral_source': '', 'verified_email': '' }
      })
    }).catch(function () {}).then(function () {
      window.dispatchEvent(new CustomEvent('sm:logout'));
      window.location.href = LOGOUT_URL + '?return_url=' + encodeURIComponent(dest);
    });
  }

  // ----- Cart Attribute Helper --------------------------------
  // Nur noch verified_email (für Apilogin-Owner-Matching im Checkout). KEIN
  // consultant_id/referral_source mehr — Attribution kommt aus Apilogin-Owner;
  // nur ein Affiliate-Link (skinmade-affiliate) setzt consultant_id explizit.
  var SmCart = {
    setVerifiedAttributes: function () {
      if (!Storage.isVerified) return Promise.resolve();
      var email = Storage.email;
      if (!email) return Promise.resolve();
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'verified_email': email } })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart update failed: ' + r.status);
        return r.json();
      });
    },
    addToCart: function (items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) {
          return r.text().then(function (t) {
            throw new Error('add failed (' + r.status + '): ' + t);
          });
        }
        return r.json();
      }).then(function (addResult) {
        return SmCart.setVerifiedAttributes()
          .catch(function (err) {
            console.warn('[SmCart] attribute write failed (non-critical):', err);
          })
          .then(function () { return addResult; });
      });
    },
    openCartDrawer: function () {
      if (typeof window.SLIDECART_UPDATE === 'function') {
        try { window.SLIDECART_UPDATE(); } catch (e) { /* ignore */ }
      }
      if (typeof window.SLIDECART_OPEN === 'function') {
        try { window.SLIDECART_OPEN(); return; } catch (e) { /* fall through */ }
      }
      document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
        bubbles: true, cancelable: false, detail: { openDrawer: true }
      }));
      document.dispatchEvent(new CustomEvent('theme:cartchanged', {
        bubbles: true, cancelable: false, detail: { openDrawer: true }
      }));
      document.dispatchEvent(new CustomEvent('theme:open-cart-drawer', {
        bubbles: true, cancelable: false
      }));
    }
  };

  // ----- Checkout-Email Pre-Fill ------------------------------
  function initCheckoutEmailPrefill() {
    if (document._smCheckoutHijacked) return;
    document._smCheckoutHijacked = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest(
        'button[name="checkout"], input[name="checkout"], ' +
        '[data-slidecart-checkout], [data-checkout-trigger]'
      );
      if (!btn) return;
      if (!Storage.isVerified) return;
      var email = Storage.email;
      if (!email) return;

      var form = btn.closest('form');
      if (!form) return;
      if (form.querySelector('input[name="checkout[email]"]')) return;

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout[email]';
      input.value = email;
      form.appendChild(input);
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      if (!/\/checkout/i.test(form.action)) return;
      if (!Storage.isVerified) return;
      var email = Storage.email;
      if (!email) return;
      if (form.querySelector('input[name="checkout[email]"]')) return;

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout[email]';
      input.value = email;
      form.appendChild(input);
    }, true);

    document.addEventListener('click', function (e) {
      if (!Storage.isVerified) return;
      var email = Storage.email;
      if (!email) return;

      var trigger = e.target.closest(
        'a[href*="/checkout"], a[href*="/checkouts/"], ' +
        '[data-checkout-trigger], [data-slidecart-checkout]'
      );
      if (!trigger) return;
      if (trigger.dataset.smCheckoutHandled) return;

      var href = trigger.getAttribute('href') || trigger.getAttribute('data-href');
      if (!href) return;
      if (/[\?&]checkout%5Bemail%5D=|[\?&]checkout\[email\]=/.test(href)) return;

      trigger.dataset.smCheckoutHandled = 'true';
      e.preventDefault();
      e.stopPropagation();

      var sep = href.indexOf('?') !== -1 ? '&' : '?';
      var encoded = encodeURIComponent(email);
      window.location.href = href + sep + 'checkout[email]=' + encoded + '&email=' + encoded;
    }, true);
  }

  // ----- Public API (stabil) ----------------------------------
  window.SmCart = SmCart;
  window.SmLogin = {
    openModal: openModal,
    closeModal: closeModal,
    logout: logout,
    isVerified: function () { return Storage.isVerified; },
    getEmail: function () { return Storage.email; },
    getName: function () { return Storage.name; },
    getConsultantId: function () { return Storage.consultantId; }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})(window);
